import {sharedEnvironment} from './shared';

export const environment = {
	production: true,
	/** Base URL of server */
	serverUrl: 'https://demo.vm.app.iovent.net/api',
	...sharedEnvironment
};
